module.exports = __webpack_public_path__ + "img/9788954615136.0fdcc3ef.jpg";